import React, { useEffect, useState } from 'react';
import { hero1, hero2, hero3, hero5, sliderImage } from '../../../assets/images';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const Hero = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; 
  const [settings, setSettings] = useState({});

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get('https://cortex-site.runasp.net/api/Settings');
        setSettings(response.data[0] || {});
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchSettings();
  }, []);

  return (
    <div
      className="relative w-full bg-cover bg-center h-[620px] md:h-[670px] font-secondFont"
      style={{ backgroundImage: `url(${hero5})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/30" />

      {/* Container */}
      <div className="relative z-10 max-w-container mx-auto h-full flex items-center justify-between">
        {/* Sol Tərəf: Məlumat */}
        <div className="w-[714px] text-white ">
          <h1 className="text-[32px] md:text-[48px] font-semibold"> 
            {t("Güclü Təməllər, Yüksək Hədəflər Üçün Çalışırıq!")}
          </h1>
          <p className="mt-5 ">
            {t("Ekonomik, sürətli və dəqiq xidmətlə işinizi etibarlı əllərə etibar edin – biz hər detalı diqqətlə idarə edərək sizin üçün ən optimal həlləri təmin edirik.")}
          </p>
          <div className='mt-8'>
            <a href={`/${currentLanguage}/about`}>
            <button className="bg-white text-[#1C1C1C] px-6 py-3 rounded-[2px] font-medium hover:bg-gray-200 transition">
              {t("Haqqımızda")}
            </button>
          </a>
          </div>
        </div>

        {/* Sağ Tərəf: Sosial Media */}
        {/* <div className="md:flex flex-col items-center space-y-4 hidden">
          <a href={settings.youtube} target="_blank" rel="noopener noreferrer">
            <img src={hero1} alt="YouTube" className="w-6 h-6" />
          </a>
          <a href={settings.instagram} target="_blank" rel="noopener noreferrer">
            <img src={hero2} alt="Instagram" className="w-6 h-6" />
          </a>
          <a href={settings.facebook} target="_blank" rel="noopener noreferrer">
            <img src={hero3} alt="Facebook" className="w-6 h-6" />
          </a>
          <div className='h-[208px] w-[1px] bg-white'>

          </div>
          <img className='w-[15px] h-[30px]' src={sliderImage}></img>
        </div> */}
      </div>
    </div>
  );
}; 

export default Hero;